import { pushUrl } from 'front-end-core/core/history'
import url from 'front-end-core/core/url'

import { includes, trim } from 'libraries/lodash'
import {
  SET_SEARCH_PAGE_LIMIT,
  SET_SEARCH_PAGINATION_MODE,
  SET_SEARCH_PHRASE,
  SET_CURRENT_SEARCH_PHRASE,
  SET_SEARCH_QUERY,
  SET_SEARCH_RESULTS,
  SET_SEARCH_TYPE,
  SET_CURRENT_SEARCH_TYPE,
  SET_PAGINATION_PAGE_NUMBER,
  SET_SEARCH_RESPONSE,
  SET_SEARCH_TYPE_DISPLAY_NAME,
  SET_SEARCH_TYPE_CLASSES,
  SET_SEARCH_HELPER_VISIBLE
} from './types'
import {
  CURRENT_AWARENESS,
  MW_LIST_DEALS,
  LEGISLATION,
  PRECEDENTS,
  QA_CONTENT,
  SEARCH,
  MW_OVERVIEW
} from 'constants/controllers'
import { pushSearchHistory } from 'services/SessionService'
import { pushEvent } from 'services/AnalyticsService'
import { clear as searchClear } from 'services/InstantSearchService'
import { AppDispatch, RootState } from 'redux/store';
import { SearchState } from 'redux/reducers/search'

export const setSearchResults = (results:any) => ({
  type: SET_SEARCH_RESULTS,
  results
})

export const setSearchPageLimit = (pageLimit:number) => ({
  type: SET_SEARCH_PAGE_LIMIT,
  pageLimit
})

export const setPaginationPageNumber = (pageNumber: number) => ({
  type: SET_PAGINATION_PAGE_NUMBER,
  pageNumber
})

export const setSearchPaginationMode = (paginationMode: 'paged'|'all') => ({
  type: SET_SEARCH_PAGINATION_MODE,
  paginationMode
})

export const setSearchQuery = (query:any) => ({
  type: SET_SEARCH_QUERY,
  query
})

export const setSearchPhrase = (searchPhrase:string) => {
  return (dispatch:AppDispatch) => {
    dispatch({
      type: SET_SEARCH_PHRASE,
      searchPhrase
    })
    dispatch(setCurrentSearchPhrase(searchPhrase))
  }
}

export const setCurrentSearchPhrase = (searchPhrase:string) => ({
  type: SET_CURRENT_SEARCH_PHRASE,
  searchPhrase
})

export const setSearchTypeDisplayName = (displayName:string) => ({
  type: SET_SEARCH_TYPE_DISPLAY_NAME,
  displayName
})

export const setSearchTypeClasses = (searchTypeClasses:string) => ({
  type: SET_SEARCH_TYPE_CLASSES,
  searchTypeClasses
})

export const setSearchHelperVisible = (searchHelperVisible:boolean) => ({
  type: SET_SEARCH_HELPER_VISIBLE,
  searchHelperVisible
})

export const setCurrentSearchType = (searchType:String) => {
  return (dispatch:AppDispatch, getState: () => RootState) => {
    dispatch({
      type: SET_CURRENT_SEARCH_TYPE,
      searchType
    })
    const searchTypes = getState().aol.searchMenu

    if (searchTypes.length) {
      const searchItem = searchTypes.filter(({ typeName }) => typeName === searchType)
      const [{ title: displayName, activeClass: searchTypeClasses }] = searchItem

      dispatch(setSearchTypeDisplayName(displayName))
      dispatch(setSearchTypeClasses(searchTypeClasses))
    }
  }
}

export const setSearchType = (searchType: string) => {
  return (dispatch:AppDispatch, _:any) => {
    dispatch({
      type: SET_SEARCH_TYPE,
      searchType
    })
    dispatch(setCurrentSearchType(searchType) as any)
  }
}

export const setSearchResponse = (response:any) => ({
  type: SET_SEARCH_RESPONSE,
  response
})

export const setSearchState = ({ pageLimit, pageNumber, paginationMode, query = {}, searchPhrase, searchType }: SearchState) => {
  return (dispatch:AppDispatch, _:any) => {
    pageLimit && dispatch(setSearchPageLimit(pageLimit))
    paginationMode && dispatch(setSearchPaginationMode(paginationMode))
    dispatch(setPaginationPageNumber(pageNumber))
    paginationMode && dispatch(setSearchPaginationMode(paginationMode))
    dispatch(setSearchQuery(query))
    searchPhrase && dispatch(setSearchPhrase(searchPhrase) as any)
    searchType && dispatch(setSearchType(searchType) as any)
  }
}

export const submitSearchUpdate = ({ params, query }: { params: any; query: any }) => {
  return (_:any, getState: () => RootState) => {
    const { search, layout: { flavour }, aol: { name: aol } } = getState()
    const { currentSearchPhrase, currentSearchType: searchType, paginationMode } = search

    const searchPhrase = trim(currentSearchPhrase)
    const pageNumber = paginationMode === 'all' ? 'all' : undefined
    const { path = 'listdeals/all' } = searchType === ([MW_OVERVIEW] as any) && (includes(params.path, 'listdeals')) && params // FIX ME remove the type casting to see the issue
    const searchQuery = { q: searchPhrase, p: pageNumber }
    const searchUrl = url(SEARCH, { aol, flavour: searchType === 'qa' && flavour, pageNumber, searchPhrase, searchType }, searchQuery)

    const searchSwitch = {
      [QA_CONTENT]: { type: `qa-${flavour.substr(0, 4)}`, url: searchUrl },
      [LEGISLATION]: { type: 'leg', url: searchUrl },
      dealwatch: {
        type: 'markets',
        url: url(MW_LIST_DEALS, { aol, path }, { ...query, page: 1, q: searchPhrase, start: 0 })
      },
      [CURRENT_AWARENESS]: { type: 'ca', url: searchUrl },
      [PRECEDENTS]: { type: 'precedents', url: searchUrl },
      marketplace: {
        type: 'marketplace',
        url: `https://www.fromcounsel.com/marketplace-search/?search=${searchPhrase}&filter=product&c_category=marketplace`
      }
    }

    if (currentSearchPhrase.length > 1) {
      const searching = searchSwitch[searchType]

      if (searching.type === 'marketplace') {
        window.location.href = searching.url
        return
      }

      pushSearchHistory(currentSearchPhrase, searching.type)
      pushEvent({
        action: 'Input',
        category: 'Search',
        label: `[${searching.type.toUpperCase()}] ${currentSearchPhrase}`
      })
      pushUrl(searching.url)
    } else if (currentSearchPhrase.length === 0) {
      searchClear()
    }
  }
}
